<nav class="tab-nav">
    <ng-container *ngFor="let tab of tabs">
        <a class="tab-title"
           [ngClass]="{ 'is-active': tab.active }"
           (click)="activateTab(tab)" *ngIf="tab.isVisible">{{ tab.name }}</a>
    </ng-container>
</nav>
<section class="tab-contents">
    <article class="tab-section" [attr.name]="tab.name" *ngFor="let tab of tabs; index as i;"
             [ngClass]="{ 'is-active': tab.active }">
        <slot name="tab_{{ i + 1 }}"></slot>
    </article>
</section>
